import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ButtonToolbar, ButtonGroup, Button } from 'react-bootstrap';


export default class ResultAnalysisToolsPlaceHolder extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.getURL = this.getURL.bind(this);
        this.getDescription = this.getDescription.bind(this);
        
    }

    handleClick(datacollectiongroup) {        
        this.props.processDataCollectionGroup(datacollectiongroup);
    }

    getDescription(job){       
        return "Run " + job + " on " +  this.props.autoprocIntegration.v_datacollection_processingPrograms + " " + this.props.autoprocIntegration.v_datacollection_summary_phasing_autoproc_space_group + " for protein " + this.props.autoprocIntegration.Protein_acronym;
    }

    getURL(job){
        return "/analysis/" + job +  "?autoprocintegrationId=" + this.props.autoprocIntegration.AutoProcIntegration_autoProcIntegrationId + "&dataCollectionId=" + this.props.autoprocIntegration.AutoProcIntegration_dataCollectionId + "&description=" + this.getDescription(job);
    }
    render() {
    var _this = this;    
    debugger    
        if (this.props.configuration.dataAnalysis.enabled) {              
            if (this.props.jobs.autoprocintegrationJobTypes) {
                return <ButtonToolbar>
                    {Object.keys(this.props.jobs.autoprocintegrationJobTypes).map(function (job) {
                        return (
                            <ButtonGroup>
                                <Link disabled target="_blank" to={_this.getURL(job)}>
                                    <Button onClick={()=>_this.handleClick(_this.props.datacollectiongroup)} bsStyle="primary">{job}</Button>
                                </Link>
                            </ButtonGroup>);
                    })}
                </ButtonToolbar>
            }
        }
        return null;
    }
}






// WEBPACK FOOTER //
// ./src/components/Mx/DataCollectionGroup/ResultListDataCollectionGroup/ResultAnalysisToolsPlaceHolder.js